var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentDataChart !== undefined
    ? _c("chart", {
        attrs: { chartData: _vm.currentDataChart, options: _vm.options },
      })
    : _c("spinner")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }